import { render, staticRenderFns } from "./PasswordChangeEmail.vue?vue&type=template&id=17cb2ad2&"
import script from "./PasswordChangeEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports